import { Cookie as CookieNames } from '@ps/web-core-enums';
import Cookies from 'universal-cookie';
import { v4 as uuidv4 } from 'uuid';

import { getWindow } from './getWindow';

const cookies = new Cookies();

export const getOrGenerateInstallId = () => {
  let installId: string | undefined = cookies.get(CookieNames.INSTALL_ID);

  if (!installId) {
    installId =
      process.env.NODE_ENV === 'test'
        ? 'testInstallId'
        : uuidv4()
            .split('-')
            .map((str) => parseInt(str, 36))
            .map((num) => num.toString())
            .join('')
            .slice(0, 18)
            .toUpperCase();
  }
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 10);
  const window = getWindow();
  if (window) {
    cookies.set(CookieNames.INSTALL_ID, installId, {
      domain: window.location.hostname.split('.').slice(1).join('.'),
      path: '/',
      expires
    });
  }
  return installId;
};
